import * as actionTypes from './actionTypes';
import { typePropertyService } from './services';
import { actionsModalError } from '@app/src/common/modalError';

const fetchTypePropertyRequest = () => ({
  type: actionTypes.FETCH_TYPE_PROPERTY_REQUEST
});

const fetchTypePropertySuccess = (data) => ({
  type: actionTypes.FETCH_TYPE_PROPERTY_SUCCESS,
  data
});

const fetchTypePropertyFailure = () => ({
  type: actionTypes.FETCH_TYPE_PROPERTY_FAILURE
});

export const fetchTypeProperty = (operationId:number): Function => {
  return async dispatch => {
    dispatch(fetchTypePropertyRequest());
    try {
      const data = await typePropertyService.get(operationId);
      dispatch(fetchTypePropertySuccess(data));
    } catch (e) {
      dispatch(fetchTypePropertyFailure());
      dispatch(actionsModalError.openModalError());
    }
  }
};
